import { useEffect, useRef, useState } from "react";
import { BellRing, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { techApi } from "../../lib/teknisiApi";
import { playNotify } from "../../lib/notifySound";

export default function TeknisiAlerts({ onUnread }) {
  const [alerts, setAlerts] = useState([]);
  const [popup, setPopup] = useState(null);
  const seen = useRef(new Set());
  const nav = useNavigate();
  useEffect(() => {
    const poll = () => techApi.get("/my/alerts").then((r) => {
      setAlerts(r.data.alerts); onUnread?.({ chat: r.data.unread_chat, group: r.data.unread_group || 0 });
      const fresh = r.data.alerts.filter((a) => !seen.current.has(a.key));
      if (fresh.length && seen.current.size) { playNotify(); setPopup(fresh[0]); }
      else if (fresh.length && r.data.new.length) { playNotify(); setPopup(fresh[0]); }
      r.data.alerts.forEach((a) => seen.current.add(a.key));
    }).catch(() => {});
    poll(); const t = setInterval(poll, 60000); return () => clearInterval(t);
  }, [onUnread]);
  if (!alerts.length) return null;
  const lv = { danger: "bg-rose-600", warn: "bg-amber-500", info: "bg-sky-600" };
  return (
    <>
      <div className="space-y-1.5" data-testid="teknisi-alerts">
        {alerts.map((a) => <button key={a.key} type="button" onClick={() => nav(a.key.startsWith("absen") ? "/teknisi" : "/teknisi/tugas")} className={`w-full text-left rounded-xl ${lv[a.level]} text-white px-3 py-2 text-xs font-semibold flex items-start gap-2 shadow`} data-testid={`teknisi-alert-${a.key}`}><BellRing className="w-4 h-4 shrink-0 mt-0.5 animate-pulse" /><span>{a.text}</span></button>)}
      </div>
      {popup && (
        <div className="fixed inset-x-0 top-14 z-50 flex justify-center px-3" data-testid="teknisi-alert-popup">
          <div className={`max-w-md w-full rounded-2xl ${lv[popup.level]} text-white p-3 shadow-2xl flex items-start gap-2`}>
            <BellRing className="w-5 h-5 shrink-0" /><div className="flex-1 text-sm font-semibold">{popup.text}</div>
            <button type="button" onClick={() => setPopup(null)} data-testid="teknisi-alert-close"><X className="w-5 h-5" /></button>
          </div>
        </div>
      )}
    </>
  );
}
